import s from './appointment-header.module.scss'
import { IconChevronLeft, IconChevronUp } from '@tabler/icons-react';
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom';
import { queryClient } from '@shared/api/query-client';

export const AppointmentHeader = ({
	mode,
	setMode,
	setIsBottomSheetShown,
	shown,
	refetch,
	isMobile,
	isTeacher,
	has_unreviewed_homework,
	appointmentIsFetching,
	has_new_homework,
	title = 'Занятие',
	showRefresh = true,
}) => {
	const navigate = useNavigate()
	const {data: profile} = queryClient.getQueryData(['profile'])

	return (
		<div className={classNames(s.appointmentHeader, shown ? s.shown : '')}>
			{isMobile ? (
				<div className={s.headerButtonsWrapper}>
					<div
						className={s.chevronFlex}
						onClick={() => setIsBottomSheetShown((p) => !p)}
					>
						<IconChevronUp className={s.iconChevron} />
						<span>Материалы и задания</span>
					</div>
				</div>
			) : (
				<button className={s.backToList} onClick={() => navigate(-1)}>
					<IconChevronLeft className={s.backToListIcon}/>
				</button>
			)}
			<div className={classNames(s.tabs, mode === 0 ? s.active : "")}>
				<button
					className={classNames(s.tab, mode === 0 ? s.active : "")}
					onClick={() => setMode(0)}
				>
					<span className={s.tabLabelFull}>Материалы занятия</span>
					<span className={s.tabLabelShort}>Материалы</span>
				</button>
				<button
					className={classNames(s.tab, mode === 1 ? s.active : "")}
					onClick={() => setMode(1)}
				>
					<span className={s.tabLabelFull}>Домашнее задание</span>
					<span className={s.tabLabelShort}>Дом. задание</span>
					{isTeacher ? (
						has_unreviewed_homework ? (
							<span
								className={s.unread}
								data-tooltip-id="tooltip-has-new-homework-result"
							></span>
						) : (
							""
						)
					) : has_new_homework ? (
						<span
							className={s.unread}
							data-tooltip-id="tooltip-has-new-homework"
						></span>
					) : (
						""
					)}
				</button>
			</div>
			{isMobile ? null : (
				<div className={s.avatar}>
					<img src={profile?.avatar ? process.env.REACT_APP_STORAGE_URL + profile?.avatar?.image : process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png'} alt="" />
				</div>
			)}
		</div>
	)
}
